import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import FullPageLayout from '../../components/layouts/FullPageLayout';
import CreateNewPassword from '../../components/pages/CreateNewPassword';
import { createNewPassword } from '../../store/actions/createNewPassword';
import token from '../../utils/token';
import Spinner from '../../components/common/Spinner';
import { signInFlow } from '../../store/actions/auth';

function CreateNewPasswordContainer(props) {
  const accessToken = token.getToken();
  useEffect(() => {
    if (accessToken && !props.shouldResetPassword) {
      props.signInFlow();
    }
  }, [accessToken, props]);

  if (accessToken && !props.shouldResetPassword) {
    return <Spinner />;
  }

  return (
    <FullPageLayout>
      <CreateNewPassword {...props} />
    </FullPageLayout>
  );
}

const mapStateToProps = (state) => {
  const { errorCode } = state.resetPassword;
  const { roles } = state.role;
  const { shouldResetPassword } = state.auth;
  return {
    errorCode,
    roles,
    shouldResetPassword,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const {
    match: { params },
  } = ownProps;

  return {
    createNewPassword: (new_password) => dispatch(createNewPassword(new_password, params.token)),
    signInFlow: () => dispatch(signInFlow()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateNewPasswordContainer);
